import { RegisterImages } from '@arcual/lib-app-neon';

export const initIcons = () => {
  RegisterImages.register();
};
